import React, { useCallback } from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';

import { SvgCheck, Icon } from '@tmapy/style-guide';

import { useAppContext, useHistoryAction } from '../../hooks';
import type { PublishsetTagResponse } from '../../openapi/types';
import { getCmdCtrlUrl } from '../../utils/getcmdctrlurl';
import { RouteId } from '../../routes';

type TagListItemProps = PublishsetTagResponse;

export const TagListItem: React.FC<TagListItemProps> = (props) => {
  const { appType } = useAppContext();
  const routeToTagDetail = useHistoryAction('vydejTagDetail', { id: props.id });

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (event.ctrlKey || event.metaKey) {
        window.open(
          getCmdCtrlUrl('vydejTagDetail' as RouteId, { appType, id: props.id }),
          '_blank',
        );
        return; // Ponech nativní chování
      }

      const selectText = window.getSelection();
      if (!selectText || selectText.toString() === '') {
        routeToTagDetail();
      }
    },
    [routeToTagDetail],
  );

  return (
    <tr onClick={handleClick}>
      <td className='sg-u-type-bold'>{props.name}</td>
      <td className='sg-a-ta-c'>
        {props.is_default && <Icon element={<SvgCheck />} size="sml" />}
      </td>
      <td className='sg-a-ta-r sg-a-fvn-tn'>
        {props.created && (
          <>
            <FormattedDate value={new Date(props.created)} />{' '}
            <FormattedTime value={new Date(props.created)} />
          </>
        )}
      </td>
      <td className='sg-a-ta-r sg-a-fvn-tn'>
        {props.edited && (
          <>
            <FormattedDate value={new Date(props.edited)} />{' '}
            <FormattedTime value={new Date(props.edited)} />
          </>
        )}
      </td>
      <td className='sg-a-ta-r sg-a-fvn-tn'>{props.publishsets_count}</td>
    </tr>
  );
};
